import React, { useContext, useEffect, useState } from 'react';
import i18n from 'i18next';
import {
    AppleLargeSvg,
    FacebookSvg,
    GoogleLargeSvg,
    LanguageSvg,
    MailLargeSvg,
    TelegramLargeSvg,
    VkLargeSvg,
    YandexLargeSvg,
} from '../../icons';
import Modal from '../modal/Modal';
import { AUTH_TYPE, IHeaderProps, ILanguages } from '../../interfaces';
import { LANGUAGES, LANGUAGES_PRICES } from '../../i18n';
import Closure from '../closure';
import { MainContext } from '../../context/main.context';
import { PROFILE_LOGO } from '../../common/constants';


export default function Header(props: IHeaderProps) {
    const { origin, userData, paymentsData } = props;
    const { language, changeLanguage } = i18n;
    const [ openLanguageMenu, setOpenLanguageMenu ] = useState(false);
    const { source, modalContent } = useContext(MainContext);

    useEffect((): void => {
        if (origin === 'prices' && !['ru', 'en'].includes(language)) {
            _changeLanguage('en');
        }
    }, []);

    const _changeLanguage = (newLang: string): void => {
        if (newLang === language) {
            setOpenLanguageMenu(false);
            return;
        }

        changeLanguage(newLang).then(r => null);
        setOpenLanguageMenu(false);
    }

    const _renderLanguages = () => {
        let _LANGUAGES: ILanguages[] = origin !== 'prices' ? [ ...LANGUAGES ] : [ ...LANGUAGES_PRICES ];

        return (
            <div className="languages-modal">
                {
                    _LANGUAGES.map((lang: ILanguages, index: number) => {
                        const { id, title } = lang;
                        const key: string = `${id}_${index}`;

                        return (
                            <div
                                key={key}
                                className="languages-modal-item"
                                onClick={() => _changeLanguage(id)}
                                style={{background: language === id ? 'rgb(227 227 227)' : 'unset'}}
                            >
                                {title}
                            </div>
                        );
                    })
                }
            </div>
        );
    }

    const _closeLanguageModal = (e: MouseEvent): void => {
        e.stopPropagation();

        setOpenLanguageMenu(false);
    }

    const _renderLanguageMenu = () => {
        return (
            <div className="language" onClick={() => setOpenLanguageMenu(true)}>
                <div className="language-value">
                    {language.toUpperCase()}
                </div>
                <LanguageSvg/>
                <Modal
                    hideCloseButton
                    open={openLanguageMenu}
                    onClose={(e: MouseEvent) => _closeLanguageModal(e)}
                >
                    {_renderLanguages()}
                </Modal>
            </div>
        )
    }

    const _renderAuthHeader = () => {
        return (
            <div className={`header ${!modalContent ? 'header-platform-auth' : 'header-modal-content'}`}>
                {!modalContent && _renderLanguageMenu()}
                {<Closure origin={origin} source={source}/>}
            </div>
        );
    }

    const _renderPaymentsHeader = () => {
        return (
            <div className="header header-platform-auth">
                <div className="header-payments-project-box">
                    <img className="header-payments-project-logo" src={PROFILE_LOGO} alt=""/>
                    <div className="text-overflow">{paymentsData?.nickName || 'USER'}</div>
                </div>
                <div className="header-payments-right-box">
                    {!modalContent && _renderLanguageMenu()}
                    {<Closure origin={origin} source={source}/>}
                </div>
            </div>
        );
    }

    const _renderTransactionsHeader = () => {
        return (
            <div className="header header-platform-auth">
                <div className="header-profile-box">
                    {_renderProfileAvatarAuth()}
                    <div className="text-overflow">
                        {userData?.nickName || 'USER'}
                    </div>
                </div>
                <Closure origin={origin} source={source}/>
            </div>
        );
    }

    const _renderProfileAvatarAuth = () => {
        const type: AUTH_TYPE | undefined = userData?.currentAuthType;

        if (type === 'google') {
            return <GoogleLargeSvg/>;
        } else if (type === 'apple') {
            return <AppleLargeSvg/>;
        } else if (type === 'vk') {
            return <VkLargeSvg/>;
        } else if (type === 'yandex') {
            return <YandexLargeSvg/>;
        } else if (type === 'telegram') {
            return <TelegramLargeSvg/>;
        } else if (type === 'facebook') {
            return <FacebookSvg width="30" height="30"/>;
        } else {
            return <MailLargeSvg/>;
        }
    }

    if (origin === 'auth') {
        return _renderAuthHeader();
    } else if (origin === 'payments') {
        return _renderPaymentsHeader();
    }  else if (['transactions', 'transactionHelper'].includes(origin)) {
        return _renderTransactionsHeader();
    }

    console.error('HEADER_ORIGIN_IS_NOT_VALID', { source, origin });
    return null;
}
